import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { creditService } from '../services/creditService';

const POLL_INTERVAL_MS = 15_000;

/**
 * Wallet balance for the signed-in user, refreshed on an interval and after
 * insufficient-credit responses so the header stays in sync with spending.
 */
export function useCreditBalance() {
  const { user } = useAuth();
  const [balance, setBalance] = useState<number | null>(null);

  const refresh = useCallback(async () => {
    try {
      const wallet = await creditService.getMyWallet();
      setBalance(wallet.balance);
    } catch {
      // Credits may not be configured yet — keep previous balance if any
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setBalance(null);
      return;
    }
    refresh();
    const intervalId = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [user, refresh]);

  useEffect(() => {
    const onInsufficient = () => {
      refresh();
    };
    document.addEventListener('insufficient-credits', onInsufficient);
    return () => document.removeEventListener('insufficient-credits', onInsufficient);
  }, [refresh]);

  return { balance, refresh };
}
